import type { ReactNode } from 'react';

import { css } from '@compiled/react';
import { UniformSlot } from '@uniformdev/canvas-react';

export interface UniformDecorativeContainerProps {
	imageSrc: string;
	children?: ReactNode;
}

const wrapperStyles = css({
	position: 'relative',
	isolation: 'isolate',
});

const decorativeImageStyles = css({
	'::before': {
		content: '""',
		display: 'block',
		position: 'absolute',
		width: '300px',
		height: '300px',
		insetBlockStart: 0,
		insetInlineStart: 0,
		transform: 'translateX(-120px) translateY(-160px)',
		backgroundImage: 'var(--decorative-bg-image)',
		backgroundSize: 'contain',
		backgroundRepeat: 'no-repeat',
		backgroundPosition: 'center',
		zIndex: -1,
		pointerEvents: 'none',
	},
});

const UniformDecorativeContainer = ({ imageSrc, children }: UniformDecorativeContainerProps) => {
	return (
		<div
			css={[wrapperStyles, decorativeImageStyles]}
			// backgroundImage must be set via inline style since the URL is a dynamic parameter
			// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
			style={{ '--decorative-bg-image': `url(${imageSrc})` } as React.CSSProperties}
		>
			{children ?? <UniformSlot name="content" />}
		</div>
	);
};

export default UniformDecorativeContainer;
